import { FC } from 'react';
import { Box, Image } from '@chakra-ui/react';

import styles from './AppAvatar.module.scss';

interface AppAvatarProps {
    icon_url: string;
    color: string;
    name: string;
}

export const AppAvatar: FC<AppAvatarProps> = ({ icon_url, color, name }) => {
    return (
        <Box className={styles.appIcon} style={{ backgroundColor: color }}>
            <Image htmlWidth={styles.appIconSize} htmlHeight={styles.appIconSize} src={icon_url} alt={name} />
        </Box>
    );
};
